import type { EventHandler, KeyboardEvent } from 'react';

export const preventFocus: EventHandler<any> = (event) => {
    event.currentTarget.blur();
};

export const stopPropagation: EventHandler<any> = (event) => {
    event.stopPropagation();
};

export const preventDefault: EventHandler<any> = (event) => {
    event.preventDefault();
};

export const preventDefaultAndStopPropagation: EventHandler<any> = (event) => {
    stopPropagation(event);
    preventDefault(event);
};

export function preventPopoverCloseOnSpacebarPress(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key === ' ') {
        stopPropagation(event);
    }
}
